import * as actions from './shared-container-single.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SpxToasterAutoCloseSpeedEnum, spxToasterActions } from '@softpak/components/spx-toaster';
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators';

import { ApiCntMethod } from 'src/app/api/api-methods.cnt';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedContainerSingleI } from 'src/app/api/shared-container-single/shared-container-single.result.int';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { loadingSharedContainerSingle } from 'src/app/shared/_config/i18n/i18n-interface';
import { spxSpinnerActions } from '@softpak/components/spx-spinner';

@Injectable()
export class SharedContainerSingleEffects {
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericService = inject(SharedGenericService);


    load$ = createEffect(() =>
        this.actions$.pipe(ofType(actions.load),
            mergeMap((params) => this.sharedGenericService.invoke(ApiCntMethod.sharedContainerSingle, {...params.data, pageType: params.pageType}).pipe(
                map((data: SharedContainerSingleI) => {
                    return actions.received({
                        data,
                        pageType: params.pageType,
                    })
                }

                ),
                takeUntil(this.actions$.pipe(
                    ofType(actions.reset),
                    filter((action) => action.pageType === params.pageType),
                )),
                catchError((error: SharedErrorObjectI) => [
                    actions.error({
                        messageText: error.message,
                        pageType: params.pageType,
                    }),
                ])
            ))
        ));

    onError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(action => [
            spxToasterActions.createError({
                autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
                messageText: action.messageText,
            }),
        ]))
    );

    afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(() => [
            spxSpinnerActions.show({
                action: loadingSharedContainerSingle
            }),
        ]))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingSharedContainerSingle
            }),
        ]))
    );

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.received),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingSharedContainerSingle
            }),
        ]))
    );

    afterReset$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.reset),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingSharedContainerSingle
            }),
        ]))
    );
}
